import {Badge, Loader} from '@mantine/core';
import React from 'react';

interface SidebarBadgeProps {
    counters: Record<string, string | number>;
    counterKeys?: string[];
    isLoading?: boolean;
    title?: string;
}

function getBadgeColor(counter: number): string {
    if (counter === 0) {
        return 'green';
    } else if (counter > 0 && counter < 20) {
        return 'blue';
    } else if (counter >= 20 && counter < 50) {
        return 'yellow';
    } else if (counter >= 50) {
        return 'red';
    } else {
        return 'gray';
    }
}

export function SidebarBadge({counters, counterKeys, isLoading = false, title}: SidebarBadgeProps) {
    if (!counterKeys || counterKeys.length === 0) {
        return null;
    }

    // Get the first counter value for color determination
    const firstCounter = counterKeys[0];
    const counterValue = Number(counters[firstCounter]) || 0;
    const badgeColor = getBadgeColor(counterValue);

    //if {var} get in counter the key
    function replaceVarInTitle() {
        if (title) {
            let key = title.split("{")[1]?.split("}")[0];
            return key ? title.replace(`{${key}}`, String(counters[key])) : title;
        }
        return null;
    }

    return (
        <Badge color={badgeColor} ms="sm"
               title={replaceVarInTitle() ?? ""}
        >
            {isLoading ? (
                <Loader size="xs" color={"white"} type="dots"/>
            ) : (
                counterKeys.map((counter, index) => (
                    <React.Fragment key={index}>
                        {counters[counter] ?? 0}
                        {index < (counterKeys.length - 1) ? " / " : ""}
                    </React.Fragment>
                ))
            )}
        </Badge>
    );
}
